var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-des-container"},_vm._l((_vm.memberDes),function(text){return _c('div',{key:text,staticClass:"des-item"},[_vm._m(0,true),_c('div',[_vm._v(_vm._s(text))])])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"icon"})])
}]

export { render, staticRenderFns }